import { cn } from '@/lib/utils'

type MinuteDropdownProps = {
  minute: number
  onMinuteChange: (value: number) => void
  onClose: () => void
}

export function MinuteDropdown({ minute, onMinuteChange, onClose }: MinuteDropdownProps) {
  const minuteOptions = Array.from({ length: 12 }, (_, i) => {
    return { value: i * 5, label: (i * 5).toString().padStart(2, '0') }
  })

  return (
    <div className="absolute top-full z-10 mt-1 max-h-48 w-full overflow-y-auto rounded border bg-white shadow-lg">
      {minuteOptions.map((minuteOption) => (
        <div
          key={minuteOption.value}
          className={cn(
            'px-3 py-1 hover:bg-gray-1 cursor-pointer text-xs',
            minute === minuteOption.value && 'bg-gray-1',
          )}
          onClick={() => {
            onMinuteChange(minuteOption.value)
            onClose()
          }}
        >
          {minuteOption.label}
        </div>
      ))}
    </div>
  )
}
